const stringToSlug = (string, toLowerCase = true) => {
  if (toLowerCase) string = string.toLowerCase()
  return string.replace(/ /g, '-').replace(/[-]+/g, '-').replace(/[^\w-]+/g, '')
}

export {
  stringToSlug
}
